
import React, { useState, useEffect } from 'react';


import { Row, Col } from 'antd';

// import 'antd/dist/antd.css';

// import UploadFile from './components/1_Upload';

import { stringify, parse } from 'svgson';
import { Button, Popover, Input, Radio, Space } from 'antd';



import { DownloadOutlined, ScissorOutlined, FormatPainterOutlined, ZoomInOutlined, ZoomOutOutlined, UndoOutlined, RedoOutlined, FileImageOutlined } from '@ant-design/icons';


// declare  setSvg, svgJoined, setMouseMode, setZoomValue, setCursor, svgHistory, historyIndex, setHistoryIndex, undoActions, setUndoActions, redoActions, setRedoActions as props in topBar
const TopBar = ({ setSvg, svgJoined, setMouseMode, setZoomValue, setCursor, svgHistory, historyIndex, setHistoryIndex, undoActions, setUndoActions, redoActions, setRedoActions, updateSVGJoined, zoomValue }) => {

    // const [svg, setSvg] = useState();
    // const [svgJoined, setSvgJoined] = useState();
    // const [color, setColor] = useState("#aabbcc");
    // const [colorHistory, setColorHistory] = useState(["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]);
    // const [mouseMode, setMouseMode] = useState("delete"); // integer state
    // const [zoomValue, setZoomValue] = useState(100); // integer state
    // const [isCanvasDisabled, setIsCanvasDisabled] = useState(false); // integer state
    // const [cursor, setCursor] = useState(`crosshair`);

    // const [svgHistory, setSvgHistory] = useState(new Array(50));
    // const [historyIndex, setHistoryIndex] = useState(0);
    // // const [startIndex, setStartIndex] = useState(0);
    // const [undoActions, setUndoActions] = useState(0);
    // const [redoActions, setRedoActions] = useState(0);

    // // keep track of current step 
    // const [step, setStep] = useState(0);


    // // const [file, setFile] = useState()
    // const [colorLayers, setColorLayers] = useState();

    function mod(n, m) {
        return ((n % m) + m) % m;
    }

    const undo = () => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        if (undoActions > 1) {
            // console.log("svgHistory: ", svgHistory);
            console.log("history index: ", (historyIndex - 2) % 50)
            let item = JSON.parse(JSON.stringify(svgHistory[mod(historyIndex - 2, 50)]));;
            setSvg(item);
            updateSVGJoined(item);

            setHistoryIndex(mod((historyIndex - 1), 50));
            setUndoActions(undoActions - 1);
            setRedoActions(redoActions + 1);
        }
    }

    const redo = () => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        if (redoActions > 0) {
            // console.log("svgHistory: ", svgHistory);
            let item = JSON.parse(JSON.stringify(svgHistory[(historyIndex) % 50]));;
            setSvg(item);
            updateSVGJoined(item);
            setHistoryIndex((historyIndex + 1) % 50);
            setRedoActions(redoActions - 1);
            setUndoActions(undoActions + 1);
        }
    }

    const download = () => {
        // console.log(groupColors());
        const blob = new Blob([stringify(svgJoined)], { type: 'image/svg+xml' });
        // uploadFile(blob, "svgColoring")
        const url = URL.createObjectURL(blob);

        console.log("link clicked");
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `trace.svg`,
        );
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }




    return (
                <>
                    <Col>
                        <Button onClick={() => { setSvg() }} style={{ width: "100%" }}><FileImageOutlined /> Change Image </Button>
                    </Col>

                    <Col style={{ minWidth: "100px" }}>
                        <Row>
                            <Radio.Group defaultValue="delete"
                                onChange={(e) => {
                                    setMouseMode(e.target.value)
                                    if (e.target.value === "fill") {
                                        setCursor(`crosshair`);
                                    }
                                    else if (e.target.value === "delete") {
                                        setCursor(`crosshair`);
                                    }
                                    else if (e.target.value === "testshape") {
                                        setCursor(`crosshair`);
                                    }
                                }
                                }

                            >
                                <Radio.Button value="fill"><FormatPainterOutlined /></Radio.Button>
                                <Radio.Button value="delete"><ScissorOutlined /></Radio.Button>
                                <Radio.Button value="testshape">TEST</Radio.Button>
                            </Radio.Group>
                        </Row>
                    </Col>

                    <Col style={{ minWidth: "100px" }}>
                        <Row>
                            <Radio.Group value="none">
                                <Radio.Button disabled={(undoActions <= 1)} onClick={() => undo()} value="undo"><UndoOutlined /></Radio.Button>
                                <Radio.Button disabled={(redoActions <= 0)} onClick={() => redo()} value="redo"><RedoOutlined /></Radio.Button>
                            </Radio.Group>
                        </Row>
                    </Col>
                    <Col style={{ minWidth: "100px" }}>
                        <Row>
                            <Radio.Group value="none">
                                <Radio.Button onClick={() => setZoomValue(zoomValue + 10)} value="zoom-in"><ZoomInOutlined /></Radio.Button>
                                <Radio.Button onClick={() => setZoomValue(zoomValue - 10)} value="zoom-out"><ZoomOutOutlined /></Radio.Button>
                            </Radio.Group>
                        </Row>
                    </Col>
                    <Col style={{ minWidth: "100px" }}>
                        <Row>
                            <Button type="primary" onClick={download} icon={<DownloadOutlined />}>
                                Download
                            </Button>
                        </Row>
                    </Col>
                </>
    );

}


export default TopBar;


